import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import { parseHandoffPayload } from "../utils/handoff";

import { setIamToken } from "./admin-api";



export function AdminHandoffPage() {

  const navigate = useNavigate();

  const [error, setError] = useState<string | null>(null);



  useEffect(() => {

    const payload = parseHandoffPayload(window.location.hash);

    if (!payload) {

      setError("Lien de connexion expiré ou invalide. Reconnectez-vous depuis la Suite ITaaS.");

      return;

    }



    const token = payload.session.tokens.accessToken;

    setIamToken(token);

    const target = payload.targetPath?.startsWith("/admin")

      ? payload.targetPath

      : "/admin/leads";

    navigate(target, { replace: true });

  }, [navigate]);



  if (error) {

    return (

      <div className="min-vh-100 d-flex align-items-center justify-content-center p-3">

        <div className="alert alert-warning" style={{ maxWidth: 480 }}>

          {error}

        </div>

      </div>

    );

  }



  return (

    <div className="min-vh-100 d-flex align-items-center justify-content-center">

      <div className="text-center">

        <div className="spinner-border text-primary mb-3" />

        <p className="text-secondary mb-0">Connexion à l&apos;administration commerciale…</p>

      </div>

    </div>

  );

}


